export const ComponentStackHelper = (() => {

    const add = (id) => {
        if (!id) {
            return;
        }

        if (!window.componentStack){
            window.componentStack = [];
        }

        window.componentStack.push(id);
    }

    const isActive = (id) => {
        if (!id && !window.componentStack) {
            return false;
        }
        return window.componentStack[window.componentStack.length - 1] === id;
    }

    const remove = (id) => {
        if (!window.componentStack)
        {
            return;
        }
        window.componentStack = window.componentStack.filter(c => c !== id);
    }

    return {
        add,
        remove,
        isActive,
    }
})();